import { Box, Line, Text } from "@prismicio/editor-ui"
import { forwardRef } from "react"

import { DocumentListBackButton } from "../app/components/DocumentListBackButton"
import { headerHeight, mainContentMaxWidth } from "../document/documentLayout"

export const MediaLibraryPageHeader = forwardRef<HTMLDivElement>(
  function MediaLibraryPageHeader(_, ref) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        height={headerHeight}
        border={{ bottom: true }}
        backgroundColor="grey2"
      >
        <Line color="purple" />
        <Box justifyContent="center" padding={16}>
          <Box width={mainContentMaxWidth} alignItems="center" gap={16}>
            <DocumentListBackButton />
            <Text variant="bold">Media Library</Text>
            <ActionPortalContainer ref={ref} />
          </Box>
        </Box>
      </Box>
    )
  },
)

const ActionPortalContainer = forwardRef<HTMLDivElement>(
  function ActionPortalContainer(_, ref) {
    return <Box ref={ref} flexGrow={1} padding={{ left: 8 }} />
  },
)
